export default __webpack_public_path__ + "77fb515ff22f676d50fb2afd81dd95bc.otf";